import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "《悬镜》口碑持续走高，冷案叙事为何打动观众",
    summary:
      "开播以来，《悬镜》凭借缜密的逻辑与克制的表达收获大量好评，成为本季度讨论度最高的悬疑剧之一。",
    content: [
      "《悬镜》自开播以来热度与口碑双线攀升，剧中以冷案重启为主线，通过一个个独立案件的推进，逐步拼凑出贯穿全剧的隐秘线索。",
      "不少观众认为，该剧最打动人的并非反转本身，而是案件背后对人性的细腻描摹。剧组在取景与美术上同样克制内敛，营造出冷静而压抑的氛围。",
      "业内人士指出，《悬镜》的成功说明观众对于扎实剧本与尊重逻辑的创作依然抱有强烈期待。",
    ],
    date: "2026-10-08",
    category: "热剧观察",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20photo%20of%20a%20modern%20detective%20crime%20series%20set%2C%20evidence%20board%20and%20dim%20blue%20lighting%2C%20atmospheric%20editorial%20photography%2C%20documentary%20style&width=800&height=600&seq=ccvideo-n1&orientation=landscape",
  },
  {
    id: "n2",
    title: "科幻大片《星际方舟》发布全新预告，视觉奇观引期待",
    summary:
      "《星际方舟》公开最新预告片，宏大的宇宙场景与细腻的人物刻画引发网友热议，被视为年度最受期待的科幻作品之一。",
    content: [
      "近日，科幻电影《星际方舟》发布全新预告片，短短两分钟的片段展现了方舟穿越星系的壮阔场面。",
      "导演林向阳表示，剧组在视觉设计上力求真实与想象力的平衡，希望让观众相信这个宇宙是真实存在的。",
      "影片将于近期与观众见面，预售渠道与相关活动信息也将陆续公布。",
    ],
    date: "2026-10-06",
    category: "新片速递",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20concept%20art%20of%20a%20huge%20spaceship%20near%20a%20blue%20nebula%2C%20epic%20scale%2C%20dark%20space%20background%20with%20glowing%20particles%2C%20high%20detail%20editorial%20still&width=800&height=600&seq=ccvideo-n2&orientation=landscape",
  },
  {
    id: "n3",
    title: "综艺市场新趋势：慢节奏内容正在回暖",
    summary:
      "从美食旅行到治愈观察，越来越多节奏舒缓的综艺获得关注，观众对真诚与陪伴感的需求正在上升。",
    content: [
      "近一段时间，以《美食环游记》为代表的慢综艺持续受到欢迎，节目通过记录真实生活场景传递温暖。",
      "分析认为，快节奏的竞技类内容依然有稳定受众，但强调陪伴感与生活质感的节目正在获得更广泛认可。",
      "平台方也表示，未来会在内容多样性上继续投入，满足不同观众群体的偏好。",
    ],
    date: "2026-10-04",
    category: "行业动态",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20variety%20show%20studio%20with%20warm%20lighting%20and%20simple%20stage%20set%2C%20soft%20neutral%20palette%2C%20clean%20editorial%20photography%20of%20tv%20production&width=800&height=600&seq=ccvideo-n3&orientation=landscape",
  },
  {
    id: "n4",
    title: "《都市之心》更新过半，群像叙事收获全年龄段观众",
    summary:
      "该剧以都市生活为切口，用细腻的群像刻画呈现年轻人真实的职场与情感，讨论度持续攀升。",
    content: [
      "《都市之心》播出过半，凭借贴近现实的剧情和鲜活的人物关系，收获了从年轻观众到中老年观众的广泛关注。",
      "编剧团队透露，剧中不少情节取材于真实访谈，希望让每个角色都经得起推敲。",
      "随着剧情进入后半程，几位主角的成长方向也成为观众热议的话题。",
    ],
    date: "2026-09-30",
    category: "热剧观察",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20dusk%20seen%20through%20office%20windows%2C%20cool%20blue%20tones%20with%20warm%20window%20lights%2C%20editorial%20photography%20of%20urban%20life&width=800&height=600&seq=ccvideo-n4&orientation=landscape",
  },
  {
    id: "n5",
    title: "经典年代剧再掀重看热潮，老作品为何历久弥新",
    summary:
      "多部年代剧在平台上重新获得高播放与讨论，观众从中寻找属于一代人的共同记忆。",
    content: [
      "近期，多部年代题材剧集在平台上重新走红，弹幕与评论区充满观众的回忆与共鸣。",
      "评论指出，这类作品之所以耐看，在于它们对时代细节的真实还原与对普通人情感的真诚书写。",
      "也有从业者表示，年代剧的复苏为创作提供了新的思路，真实永远是最有力的表达。",
    ],
    date: "2026-09-26",
    category: "深度解读",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20old%20courtyard%20home%20with%20red%20lanterns%20at%20dusk%2C%20warm%20amber%20and%20teal%20tones%2C%20soft%20film%20grain%20editorial%20photography&width=800&height=600&seq=ccvideo-n5&orientation=landscape",
  },
  {
    id: "n6",
    title: "音乐竞演节目《音乐无界》开启新赛季，原创作品成亮点",
    summary:
      "新一季节目在赛制上做出调整，为原创音乐提供更多展示空间，多位唱将带来全新改编。",
    content: [
      "《音乐无界》新赛季正式开录，节目在保留经典改编环节的同时，加大了对原创作品的呈现比重。",
      "多位实力唱将表示，希望通过舞台让更多优质原创被听见。",
      "节目组透露，本季将增设幕后创作记录环节，让观众看到一首歌从灵感到呈现的完整过程。",
    ],
    date: "2026-09-22",
    category: "综艺前瞻",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20warm%20spotlight%20and%20glowing%20particles%2C%20dramatic%20blue%20and%20gold%20lighting%2C%20editorial%20photography%20of%20live%20music%20venue&width=800&height=600&seq=ccvideo-n6&orientation=landscape",
  },
  {
    id: "n7",
    title: "奇幻剧《山海秘境》美术特辑公开，东方美学获赞",
    summary:
      "剧组发布美术特辑，展示从场景搭建到服装设计的完整创作过程，观众直呼「每一帧都是壁纸」。",
    content: [
      "《山海秘境》官方发布美术特辑，首次系统展示该剧在场景、服装与道具上的设计思路。",
      "主创团队表示，希望在奇幻设定中融入东方审美，让观众感受到独特的视觉气质。",
      "特辑发布后引发广泛讨论，不少观众表示对剧集后续内容更加期待。",
    ],
    date: "2026-09-18",
    category: "幕后揭秘",
    cover:
      "https://readdy.ai/api/search-image?query=Misty%20fantasy%20mountains%20with%20traditional%20Chinese%20architecture%20and%20floating%20islands%2C%20jade%20green%20and%20deep%20blue%20palette%2C%20ethereal%20concept%20art%20editorial&width=800&height=600&seq=ccvideo-n7&orientation=landscape",
  },
  {
    id: "n8",
    title: "悬疑题材持续升温，平台加码短剧集布局",
    summary:
      "多部短小精悍的迷你剧获得不错反响，平台正加大在精品短剧上的投入，内容竞争进入新阶段。",
    content: [
      "随着观众对节奏要求提高，短剧集凭借紧凑叙事与完整体验获得更多关注。",
      "多家平台表示，将继续扶持优质短剧集项目，在剧本与制作上提升标准。",
      "业内人士认为，内容形式的多样化将推动行业整体质量提升。",
    ],
    date: "2026-09-14",
    category: "行业动态",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20moody%20photo%20of%20a%20film%20clapperboard%20and%20spotlight%20in%20a%20studio%2C%20deep%20blue%20and%20amber%20tones%2C%20editorial%20photography%20of%20filmmaking&width=800&height=600&seq=ccvideo-n8&orientation=landscape",
  },
];